import { z } from "zod";

export const UpdateRateSchema = z
    .object({
        name: z.string().nonempty('Rate name is required'),
        description: z.string().optional(),
        max_night: z.coerce.number()
            .int()
            .min(0, 'Max night is required. It must be at least 0. If set to 0, there will be no limit for max night.'),
        min_night: z.coerce.number()
            .int()
            .min(1, 'Min night must be greater than 0'),
        guest_include: z.coerce.number()
            .int()
            .min(1, 'Guest include is required and must be at least 1'),
        guest_max: z.coerce.number()
            .int()
            .min(1, 'Guest max is required and must be at least 1'),
        extra_adult: z.coerce.number()
            .int()
            .nullable(),
        extra_child: z.coerce.number()
            .int()
            .nullable(),
        extra_adult_rate: z.coerce.number().nullable(),
        extra_child_rate: z.coerce.number().nullable(),
        min_rate: z.coerce.number()
            .min(0, 'Min rate must be 0 or greater'),
        rate: z.coerce.number()
            .min(0, 'Rate must be 0 or greater'),
    })
    .superRefine((data, ctx) => {
        if (data.guest_max < data.guest_include) {
            ctx.addIssue({
                path: ['guest_max'],
                code: z.ZodIssueCode.custom,
                message: 'Guest max must be greater than or equal to guest include',
            });
        }

        if (data.rate < data.min_rate) {
            ctx.addIssue({
                path: ['rate'],
                code: z.ZodIssueCode.custom,
                message: 'Rate must be greater than or equal to min rate',
            });
        }
    });